import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Form as FormInput, Button } from 'react-bootstrap';

class Form extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.element),
    className: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    submitTxt: PropTypes.string
  };

  constructor() {
    super();
    this.data = new Map();
  }

  handleSubmit = ev => {
    ev.preventDefault();
    this.props.onSubmit(this.data);
  };

  handleChange = ev => {
    const target = ev.target;
    const type = target.getAttribute('type');
    const key = target.getAttribute('name');
    const value = type === 'checkbox' ? target.checked : target.value;
    this.data.set(key, value);
  };

  render() {
    const validFormComponents = ['FormInput', 'FormCellphone'];
    const children = React.Children.map(this.props.children, child => {
      if (!child) {
        return child;
      }
      if (validFormComponents.indexOf(child.type.displayName) != -1) {
        return React.cloneElement(child, {
          onChange: ev =>
            this.props.handleChange
              ? this.props.handleChange(ev)
              : this.handleChange(ev)
        });
      } else {
        return child;
      }
    });

    const { submitTxt, ...props } = this.props;

    return (
      <div>
        <FormInput {...props} onSubmit={this.handleSubmit}>
          {children}
          <Button bsStyle="primary" type="submit">
            {submitTxt}
          </Button>
        </FormInput>
      </div>
    );
  }
}

export default Form;
